(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 51584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 20394:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(18231);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Picture; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/Picture/Picture.jsx








var shimmer = function(width, height, theme) {
    return '\n    <svg width="'.concat(width, '" height="').concat(height, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n        <defs>\n            <linearGradient id="gradient" gradientTransform="rotate(10)">\n                <stop stop-color="').concat(theme === "dark" ? "#3F3D52" : "#FCFCFC", '" offset="20%" />\n                <stop stop-color="').concat(theme === "dark" ? "#434157" : "#F7F7FF", '" offset="50%" />\n                <stop stop-color="').concat(theme === "dark" ? "#3F3D52" : "#FCFCFC", '" offset="70%" />\n            </linearGradient>\n        </defs>\n        <rect fill="').concat(theme === "dark" ? "#3F3D52" : "#FCFCFC", '" width="').concat(width, '" height="').concat(height, '" />\n        <rect id="r" width="').concat(width, '" height="').concat(height, '" fill="url(#gradient)" />\n        <animate xlink:href="#r" attributeName="x" from="-').concat(width, '" to="').concat(width, '" dur="1s" repeatCount="indefinite" />\n    </svg>\n');
};
var toBase64 = function(str) {
    return  false ? 0 : window.btoa(str);
};
var Picture = function(param) {
    var children = param.children, mods = param.mods, image = param.image, sizes = param.sizes, priority = param.priority, theme = param.theme, alt = param.alt, order = param.order, props = param.props, classNameTail = param.className, imageClassName = param.imageClassName;
    var className = (0,useMods/* default */.Z)(Picture, {
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            order: order
        })
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,css/* default */.Z)(className, classNameTail),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({
                src: image,
                placeholder: "blur",
                blurDataURL: "data:image/svg+xml;base64,".concat(toBase64(shimmer(image.width, image.height, theme))),
                sizes: sizes,
                loading: priority ? "eager" : "lazy",
                quality: 85,
                alt: alt,
                priority: priority,
                className: imageClassName
            }, props)),
            children
        ]
    });
};
Picture.displayName = "Picture";
Picture.propTypes = {
    alt: (prop_types_default()).string.isRequired,
    image: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]).isRequired,
    mods: (prop_types_default()).object,
    order: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).bool
    ]),
    priority: (prop_types_default()).bool,
    sizes: (prop_types_default()).string,
    theme: (prop_types_default()).string,
    props: (prop_types_default()).object
};
Picture.defaultProps = {
    mods: {},
    priority: false,
    sizes: "(min-width: 1280px) 50vw, (min-width: 1024px) 40vw, (min-width: 768px) 45vw, (min-width: 425px) 50vw, 20vw",
    theme: "light"
};
/* harmony default export */ var Picture_Picture = (Picture);

;// CONCATENATED MODULE: ./src/components/UI/Picture/index.js

/* harmony default export */ var UI_Picture = (Picture_Picture);


/***/ }),

/***/ 18231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_404; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Seo/index.js
var Seo = __webpack_require__(40845);
// EXTERNAL MODULE: ./src/layouts/Layout/index.js + 16 modules
var Layout = __webpack_require__(65305);
// EXTERNAL MODULE: ./src/components/Info/index.js + 1 modules
var Info = __webpack_require__(54491);
// EXTERNAL MODULE: ./src/components/UI/Link/index.js + 1 modules
var Link = __webpack_require__(57202);
// EXTERNAL MODULE: ./src/components/UI/Picture/index.js + 1 modules
var Picture = __webpack_require__(85593);
// EXTERNAL MODULE: ./src/components/UI/Typography/Heading/index.js + 1 modules
var Heading = __webpack_require__(70408);
// EXTERNAL MODULE: ./src/components/UI/Typography/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(39466);
;// CONCATENATED MODULE: ./src/assets/Images/404.png
/* harmony default export */ var _404 = ({"src":"/_next/static/media/404.fd146fd2.png","height":720,"width":720,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABE0lEQVR4nAEIAff+AZubpQA6OjUjExMTjAYGBiMBAQDiEBAMmaOkrrMcGxgCAZWWoSIoJyLCHx8dGwkJCgDz8/IACQkKAPT09W8QEA+SAaqqtJUJCQhqHBwa+QUGBgb09PT9+/r7BPr6+gBCQjo5AZWUnckVFhc2AwQD/g8PDwIFBAIACgsN/g0NCQICAQHoAa2ttPwFBgkDEhEMAAsLCgD29/kA7u/z/xcVEgEPDgz4AbKyucghIiI3AgID/Pv7+gIZGRgA6urs//b18wP19fRdAcPDyLAREBBP/P3+ACEhIAADAwIA09PUANHR0wDp6OsoAZiYn0AEAwRbHB0aHz09OxTn5+n/jo2T6g8PDtJZWlWLxVthEJEteAIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/layouts/Navigation/Traqq/index.js + 2 modules
var Traqq = __webpack_require__(94665);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/screens/Errors/404/404.jsx









var NotFound = function() {
    var ref = (0,react.useState)(106), navbar = ref[0], setNavbar = ref[1];
    (0,react.useEffect)(function() {
        return setNavbar(document.querySelector(".navbar"));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Traqq/* default */.Z, {
                theme: "dark",
                background: "violet"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "not-found-wrap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "not-found",
                    style: {
                        height: "calc(100vh - ".concat(navbar > 0 ? navbar : navbar.offsetHeight, "px)")
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    tag: "h1",
                                    color: "white",
                                    mods: {
                                        "12xl": true
                                    },
                                    children: "404"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                                    tag: "p",
                                    size: "lg",
                                    color: "white",
                                    children: [
                                        "Page not found! Meanwhile, ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: "/",
                                            mods: {
                                                underline: true
                                            },
                                            children: "read how to increase productivity"
                                        }),
                                        " with Traqq and manage remote and local employees."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "not-found__image",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                                image: _404,
                                alt: "404"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var _404_404 = (NotFound);

;// CONCATENATED MODULE: ./src/screens/Errors/404/index.js

/* harmony default export */ var Errors_404 = (_404_404);

;// CONCATENATED MODULE: ./src/pages/404.js





var title = "Page not found";
var description = "Page not found... Go to the home page of Traqq - a simple and intuitive time tracker designed for teams and individuals a like.";
var NotFoundPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        title: title,
        description: description,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* NextSeoTraqq */.$E, {
                noindex: true,
                nofollow: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Errors_404, {})
        ]
    });
};
/* harmony default export */ var pages_404 = (/*#__PURE__*/(0,react.memo)(NotFoundPage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5646,1608,5555,4665,9774,2888,179], function() { return __webpack_exec__(20394); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);